import { FC } from 'react';
import OtpInputBase from './OtpInputBase';

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  numInputs?: number;
  label?: string;
}

const OtpInput: FC<OtpInputProps> = (props) => {
  return <OtpInputBase {...props} />;
};

export default OtpInput;
